import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ASYNC_USER_LOGIN } from 'store';
import { Link, Redirect } from 'react-router-dom';
import { Form, Button, Alert, Row, Col, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './style.css';
import LoginService from '../../services/login';
import history from '../history';
import * as logoLight from "../../images/logo-light.png"
import * as logo from "../../images/logo.png"
import * as logoWhite from "../../images/logo-branco-scan.png";

import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { t } = useTranslation();

  useEffect(() => {

  }, [errorMessage]);

  let isLogged = localStorage.getItem("token") && localStorage.getItem("username");

  if (isLogged)
     return <Redirect to='/sumo/quote-request' />;

  const authenticateData = (email, password) => {
     let response = LoginService.login(email, password);
     response.then((data) => {
        let info = data.data;

        if (info.message) {
           setErrorMessage("Invalid Credentials");
        } else {

          info = info.data;
      
          localStorage.setItem('token', info.access_token);
          localStorage.setItem('username', info.user.name);
          localStorage.setItem('profile', info.user.profiles[0].name);
          localStorage.setItem('routes', JSON.stringify(info.user.profiles[0].routes));
          return history.push("quote-request");
        }

     }).catch( (error) => {
       setErrorMessage("error");
     });
  }

  return (
    <div className="login" id="login">
      <Row className="h-100 m-0 row-page backgprund-img-class">
        <Col md="5" className="h-100 p-0 m-0 areaForm">
          <div className="login-form">
            <span>
              <img src={logoLight} alt="SCANSOURCE" className="scan-logo" />
            </span>
            <div className="login-text">
              <h5 className="login-h5">Log in.</h5>
              <span className="login-span">Insira seus dados de acesso</span>
            </div>
            {!!errorMessage && (
              <Alert className="mt-4" variant="danger">
                {errorMessage}
              </Alert>
            )}
            <Form
              onSubmit={e => {
                e.preventDefault();
                authenticateData(email, password);
              }}
            >
              <Form.Group>
                <Form.Label className="form-label">{t('label:email')}</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>
                      <MailOutlineIcon className="icon-input" />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="email"
                    placeholder={t('phrase:type your email')}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group>
                <Form.Label className="form-label">{t('label:password')}</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>
                      <LockOutlinedIcon className="icon-input" />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="password"
                    placeholder={t('phrase:type your password')}
                    onChange={e => setPassword(e.target.value)}
                    required
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group>
                <Form.Check className="form-label" type="checkbox" label={t('phrase:remember me')} />
              </Form.Group>
              <Button block type="submit" className="login-btn">
                Login
              </Button>
              <p className="text-center mt-2">
                <Link to="/" className="forgot-password">
                  {t('phrase:forgot your password')}
                </Link>
              </p>
            </Form>
          </div>
        </Col>
        <Col md="7" className="h-100 p-0 m-0 mobileHidden left-area">
          <div id='backgprund-img'></div>
          <div className="logo-trend">
            <div className="scan-logo-white text-center">
              <span>
                <img src={logoWhite} alt="ScanSource" width="250" />
              </span>
            </div>
            <div className="scan-site mt-3 text-center">
              <span>
                www.scansource.com.br
              </span>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => {};

const mapDispatchToProps = dispatch => ({
  login: (email, password) =>
    dispatch({
      type: ASYNC_USER_LOGIN,
      payload: { email, password }
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
